import { render, staticRenderFns } from "./BoxContent.vue?vue&type=template&id=352b98b7&scoped=true&"
import script from "./BoxContent.vue?vue&type=script&lang=js&"
export * from "./BoxContent.vue?vue&type=script&lang=js&"
import style0 from "./BoxContent.vue?vue&type=style&index=0&id=352b98b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b98b7",
  null
  
)

export default component.exports